var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3074_7240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 1.3335C4.31203 1.3335 1.33203 4.3135 1.33203 8.00016C1.33203 11.6868 4.31203 14.6668 7.9987 14.6668C11.6854 14.6668 14.6654 11.6868 14.6654 8.00016C14.6654 4.3135 11.6854 1.3335 7.9987 1.3335ZM11.332 10.3935L10.392 11.3335L7.9987 8.94016L5.60536 11.3335L4.66536 10.3935L7.0587 8.00016L4.66536 5.60683L5.60536 4.66683L7.9987 7.06016L10.392 4.66683L11.332 5.60683L8.9387 8.00016L11.332 10.3935Z",
    fill: "#FF9999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3074_7240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.9468a6aa531c2f43c246680fb382e98d.svg";
export { ForwardRef as ReactComponent };